module.exports = __webpack_public_path__ + "img/ic_export_records.90375cc6.svg";